<div [@fadeAnimation]="isOpen ? 'show' : 'hide'" [className]="'notification' + ' ' + currentStyle">
    {{message}}
</div>
